// import styles from './orders-page.module.scss'
import { PageContainer } from 'components'
import { PageHeader } from '@touche-lts/panel-ui/dist'
import { IconOrders } from '@touche-lts/panel-ui/dist/assets/svg'
import { observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'
import { useRootStore } from 'mobx-stores/store-provider'
import { OrdersTable } from './orders-table/orders-table'
import { OrderDetails } from './order-details/order-details'
import cl from 'classnames'
import styles from './orders-page.module.scss'

const OrdersPageComponent = () => {

  const {
    ordersDetailsStore: {
      setOrderDetails,
      isOrderDetailsVisible
    }
  } = useRootStore(),

  orderDetailsRef: any = useRef(),

  handleClickOutside = (event) => {
    if (orderDetailsRef.current && !orderDetailsRef.current.contains(event.target)) {
      setOrderDetails(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
        document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return (
    <PageContainer className={cl('container', styles.container)}>
        <div className="d-flex justify-content-around">
            <PageHeader
            navSegments={[
                {
                icon: IconOrders,
                label: 'Orders'
                }
            ]}
            colorPreset='dark'
            /> 
            
            {/* <p>Period</p> // TODO-A This may be needed later
            <Select<OrdersPeriodFilter>
                colorPreset='dark'
                options={ordersPeriodFilterOptions}
                noNoneOption
                value={OrdersPeriodFilter.WEEK}
                placeholder='Past Week'
                className={styles.selectRootClassName}
                onChange={type =>
                    console.log(type)
                }
            />  */}
        </div>
        <OrdersTable />
        <div ref={orderDetailsRef}>
          {isOrderDetailsVisible && (
            <OrderDetails />
          )}
        </div>       
    </PageContainer>
  )
},

OrdersPage = observer(OrdersPageComponent)
export { OrdersPage }
